"use client";

import PLPBanner from "@/components/common/shared/ProductListing/components/PLPBanner";

const EngineOilBanner = ({ bannerImages }) => {
  return (
    <div className="sm:py-6 xs:py-5 py-0">
      <PLPBanner {...bannerImages} />
    </div>
  );
};

export default EngineOilBanner;
